import { oneOf, string, oneOfType, bool } from 'prop-types';
var buttonTypePropType = oneOf(['default', 'outlined', 'link', 'ghost']);
var breakpointPropType = oneOf(['fullHD', 'widescreen', 'desktop', 'tablet', 'mobile']);
var columnSpreadPropType = oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
var columnSpreadOffsetPropType = oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 'left', 'both', 'right']);
var placementPropType = oneOf(['auto', 'top', 'right', 'bottom', 'left', 'top-start', 'right-start', 'bottom-start', 'left-start', 'top-end', 'right-end', 'bottom-end', 'left-end']);
var sizePropType = oneOf(['default', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge']);
var animatePropTypes = {
  delay: string,
  duration: string,
  expand: oneOfType([bool, oneOf(['bottom', 'left', 'right', 'top', 'center'])]),
  fade: bool,
  slide: oneOfType([bool, oneOf(['bottom', 'left', 'right', 'top'])]),
  timing: string
};
var animateDefaultProps = {
  delay: undefined,
  duration: '250ms',
  expand: undefined,
  fade: false,
  slide: false,
  timing: undefined
};
var restrictHidePropTypes = {
  hideOnEsc: bool,
  hideOnClickOutside: bool
};
var restrictDefaultProps = {
  hideOnEsc: undefined,
  hideOnClickOutside: undefined
};
export { animateDefaultProps, animatePropTypes, breakpointPropType, buttonTypePropType, columnSpreadOffsetPropType, columnSpreadPropType, placementPropType, restrictDefaultProps, restrictHidePropTypes, sizePropType };